import { BorderBase } from './border-base';
export class LayoutBorder extends BorderBase {
}
